import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'modules/user/UAvatar.component';
import { Row, View, CommentText, styled, Pressable } from 'modules/styled';

const Container = styled(View)({
  px: 1,
  flexShrink: 1,
  maxHeight: 4.5 * 8.01,
  overflow: 'hidden',
});

class PostComment extends Component {
  static propTypes = {
    auth: PropTypes.object,
    comment: PropTypes.object,
    postUrl: PropTypes.string,
  };

  render() {
    const { comment, auth, postUrl } = this.props;
    if (!comment || !comment.body) {
      return null;
    }
    return (
      <Row sx={{ mt: 2, alignItems: 'center' }}>
        <Avatar
          user={comment.embeddedUser}
          auth={auth}
          postTime={comment.postDate}
          setSelected={() => {
            console.warning('TODO:'); // eslint-disable-line
          }}
          showRelevance
        />
        <Container>
          <Pressable to={postUrl}>
            <CommentText>{comment.body}</CommentText>
          </Pressable>
        </Container>
      </Row>
    );
  }
}

export default PostComment;
